import config, { FEATURE_FLAGS } from '@/libs/utils/config';

export function landlordActivatePlanRedirect(to, from, next) {
  if (config.features.has(FEATURE_FLAGS.LANDLORD_SIGNATURE_IMPROVEMENTS)) {
    next();
  } else {
    window.location.href = '/';
  }
}
